import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { NoDeliveryReasonModel } from '@app/models';

@Injectable({
    providedIn: 'root',
})
export class NoDeliveryReasonService
{
    private endPoint = '/noDeliveryReasons';
    private http = inject(HttpClient);

    getNoDeliveryReasons(): Promise<NoDeliveryReasonModel[]>
    {
        return firstValueFrom(this.http.get<NoDeliveryReasonModel[]>(this.endPoint));
    }
}
